import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Error = _resolveComponent("Error")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_TopNavigation = _resolveComponent("TopNavigation")!
  const _component_Footer = _resolveComponent("Footer")!
  const _component_SessionTimeoutModal = _resolveComponent("SessionTimeoutModal")!
  const _component_FeatureFlagFlipper = _resolveComponent("FeatureFlagFlipper")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.apiConnectionError || _ctx.maintenanceMode)
      ? (_openBlock(), _createBlock(_component_Error, { key: 0 }))
      : (_ctx.isEmbedRoute)
        ? (_openBlock(), _createBlock(_component_router_view, { key: 1 }))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            (_ctx.$auth.isAuthenticated.value)
              ? (_openBlock(), _createBlock(_component_TopNavigation, { key: 0 }))
              : _createCommentVNode("", true),
            (_openBlock(), _createBlock(_component_router_view, {
              key: _ctx.currentRoute.name,
              class: "pl-3 pr-3 pt-28"
            })),
            (_ctx.$auth.isAuthenticated.value)
              ? (_openBlock(), _createBlock(_component_Footer, { key: 1 }))
              : _createCommentVNode("", true),
            (_ctx.showSessionTimeoutModal)
              ? (_openBlock(), _createBlock(_component_SessionTimeoutModal, {
                  key: 2,
                  onCloseModal: _ctx.methods.closeSessionModal
                }, null, 8, ["onCloseModal"]))
              : _createCommentVNode("", true)
          ], 64)),
    (_ctx.canToggleFeatures)
      ? (_openBlock(), _createBlock(_component_FeatureFlagFlipper, { key: 3 }))
      : _createCommentVNode("", true)
  ], 64))
}